// communications-api — endpoints de listagem de comunicações.

import { z } from 'zod';

import { apiClient } from './api-client';

export const communicationItemSchema = z.object({
  id: z.string().uuid(),
  clientId: z.string().uuid(),
  direction: z.string(),
  channel: z.string(),
  templateKey: z.string().nullable(),
  subject: z.string().nullable(),
  body: z.string(),
  status: z.string(),
  sentAt: z.string().nullable(),
  deliveredAt: z.string().nullable(),
  failedAt: z.string().nullable(),
  errorMessage: z.string().nullable(),
  attemptsCount: z.number(),
  createdAt: z.string(),
  client: z.object({ id: z.string().uuid(), name: z.string() }),
});
export type CommunicationItem = z.infer<typeof communicationItemSchema>;

const listResponseSchema = z.object({
  data: z.array(communicationItemSchema),
  pagination: z.object({
    page: z.number(),
    pageSize: z.number(),
    total: z.number(),
  }),
});

export interface CommunicationsFilters {
  clientId?: string;
  channel?: 'whatsapp' | 'email' | 'sms';
  status?: string;
  direction?: 'outbound' | 'inbound';
  page?: number;
  pageSize?: number;
}

export async function listCommunications(
  filters: CommunicationsFilters = {},
  signal?: AbortSignal,
): Promise<z.infer<typeof listResponseSchema>> {
  const params: Record<string, string | number> = {};
  if (filters.clientId) params.clientId = filters.clientId;
  if (filters.channel) params.channel = filters.channel;
  if (filters.status) params.status = filters.status;
  if (filters.direction) params.direction = filters.direction;
  if (filters.page) params.page = filters.page;
  if (filters.pageSize) params.pageSize = filters.pageSize;

  const { data } = await apiClient.get('/api/communications', { params, signal });
  return listResponseSchema.parse(data);
}
